var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.active)?_c('div',{staticClass:"loading-container",style:({ width: _vm.width, height: _vm.height })},[_c('div',{staticClass:"dots-loader",style:({ '--dot-color': _vm.color })},[_c('span'),_c('span'),_c('span')])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }